// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"db689a75a134e41f","4110":"e81304dab0bc8ab7","5405":"6fbfc0d199a83daa"}[chunkId] + ".css";
};